import { FormLabel, RadioField, RadioFieldGroup } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { DataFieldIndexResource } from "../types/dataField";

interface Props {
	dataField: DataFieldIndexResource;
	disabled?: boolean;
	name: string;
}

const StyledFormLabel = styled(FormLabel)`
	display: block;
	margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const RadioDataField: FC<Props> = ({ name, dataField, disabled }) => {
	return (
		<div>
			<StyledFormLabel>{dataField.label}</StyledFormLabel>
			<RadioFieldGroup name={name}>
				{dataField.options.map((o) => (
					<RadioField key={`${name}_${o.id}`} value={`${o.id}`} label={o.value} disabled={disabled} />
				))}
			</RadioFieldGroup>
		</div>
	);
};
